import { Component, EventEmitter, Injector, OnInit, Output, ViewChild } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { AppConsts } from '@shared/commonHelper/AppConsts';
import { CreateSubscriptionInputDto, LocalBillingDetailInput, ServiceProxy } from '@shared/service-proxies/stripe-service-proxy';
import { cloneDeep } from 'lodash';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'vf-error-processing-stripe-modal',
    templateUrl: './error-processing-stripe-modal.component.html'
})
export class ErrorProcessingStripeModalComponent extends AppComponentBase implements OnInit {

    @ViewChild('errorProcessingStripe') modal: ModalDirective;
    @Output() subscriptionSuccessEmit: EventEmitter<void> = new EventEmitter<void>();
    @Output() tryAnotherInsideModal: EventEmitter<any> = new EventEmitter<any>();
    localBillingDetail: LocalBillingDetailInput = new LocalBillingDetailInput();
    isFromBanner = false;
    busyLoad = false;
    amount = 0;
    prodDetail: any;
    cardLast4 = '';
    planType = 0;

    constructor(
        injector: Injector,
        private _serviceProxy: ServiceProxy
    ) {
        super(injector);
    }

    ngOnInit() {
    }

    show(data?: any): void {
        this.localBillingDetail = cloneDeep(data[0]);
        // data[1] is the card element — no longer used (destroyed when billing modal closed)
        // data[2] is priceId — no longer needed for retry
        this.isFromBanner = data[3];
        this.amount = data[4];
        this.prodDetail = data[5] || null;
        this.cardLast4 = data[6] || '';

        // Derive planType: from prodDetail if available, otherwise from amount
        if (this.prodDetail && this.prodDetail[1] !== undefined) {
            this.planType = this.prodDetail[1] === 0 ? 4 : 1;
        } else {
            // Fallback: derive from amount ($190 = annual, $19 = monthly)
            this.planType = this.amount === 190 ? 4 : 1;
        }

        this.modal.show();
        setTimeout(() => {
            this.updateBodyForCenterModalShow();
        }, 600);
    }

    close(): void {
        this.modal.hide();
        this.updateBodyForCenterModalHide();
    }

    retrySubscription(): void {
        let quantity = this.localBillingDetail.noOfUsers;

        const input = new CreateSubscriptionInputDto();
        input.type = this.planType;
        input.quantity = quantity;
        this.busyLoad = true;
        this._serviceProxy.createSubscription(input).subscribe(result => {
            this.busyLoad = false;
            if (!result.isError) {
                this.toastr.success('Successfully subscribed to a Plan.', null, AppConsts.toastrOption);
                this.close();
                this.subscriptionSuccessEmit.emit();
            } else {
                this.toastr.error('Payment failed again. Please try updating your card.', null, AppConsts.toastrOption);
            }
        });
    }

    updateCard(): void {
        this.close();

        if (this.prodDetail) {
            // Array-based flow (from trial-ended modal): prodDetail = [productDetails, selectedPlanId, isFromBanner, ...]
            let prodDetails = this.prodDetail[0];
            let selectedPlanId = this.prodDetail[1];

            this.tryAnotherInsideModal.emit([prodDetails, selectedPlanId, this.isFromBanner, true]);
        } else {
            // Upgrade modal flow: reopen billing detail modal with object format
            let plan = this.planType === 4 ? 'annual' : 'monthly';
            let quantity = this.localBillingDetail.noOfUsers || 2;
            let total = this.amount * quantity;

            this.tryAnotherInsideModal.emit({ plan: plan, quantity: quantity, total: total });
        }
    }
}
